import { useEffect } from 'react';

export function useDocumentTitle(title) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} | CRATELAB` : 'CRATELAB | Professional DJ Track Analyzer';
    return () => { document.title = prev; };
  }, [title]);
}
